/** * Voice video functionality - adds "play again" button for videos with [voice] alt text */
function initVoiceVideoPlayAgain() {
    const videos = document.getElementsByTagName("video");

    if (videos.length) {
      const voiceVideos = Array.from(videos).filter(video => {
          const ariaLabel = video.getAttribute('aria-label');
          return ariaLabel && ariaLabel.includes('[voice]');
      });

      /** * Add event listeners to voice videos to show play again button when video ends * @param {HTMLVideoElement[]} voiceVideos - Array of voice video elements */
      voiceVideos.forEach((video) => {
          video.addEventListener("ended", () => {
              // Find the Plyr control overlay button
              const playButton = video.closest('.plyr')?.querySelector('.plyr__control--overlaid') || video.parentElement?.querySelector('.plyr__control--overlaid');
              if (playButton) {
                  playButton.classList.add('voice-video-played');
              }
          });
      });
    }

}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', initVoiceVideoPlayAgain);